import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { ReactComponent as Icon1 } from "../icons/dashboard.svg";
import { ReactComponent as Icon2 } from "../icons/errors.svg";
import { ReactComponent as Icon3 } from "../icons/validation.svg";
import { ReactComponent as Icon4 } from "../icons/toccompare.svg";
import { ReactComponent as Icon5 } from "../icons/package_creation.svg";
import { ReactComponent as Icon6 } from "../icons/add.svg";
import { ReactComponent as Icon7 } from "../icons/edit.svg";
import { ReactComponent as Icon8 } from "../icons/delete.svg";
import { ReactComponent as Icon9 } from "../icons/html.svg";
import { ReactComponent as Icon10 } from "../icons/CastOff.svg";
import { ReactComponent as Icon11 } from "../icons/question.svg";
import { ReactComponent as Icon12 } from "../icons/DITA.svg";
import { ReactComponent as Icon13 } from "../icons/TB.svg";
import { ReactComponent as Icon14 } from "../icons/csv.svg";
import { useAuth } from "./Auth/userContext";

const panellist = [
  { title: "XML To DITA", icon: <Icon1 />, url: "xml_to_dita" },
  { title: "Word To DITA", icon: <Icon12 />, url: "word_to_dita" },
  { title: "Word To IM", icon: <Icon5 />, url: "word_to_im" },
    { title: "Q&A to DITA", icon: <Icon11 />, url: "QA_to_dita" },
  { title: "Word To TB", icon: <Icon13 />, url: "word_to_tb" },
  {
    title: "Excel To DITA",
    icon: <Icon3 />,
    url: "excel_to_dita",
  },
  {
    title: "XML to HTML",
    icon: <Icon9 />,
    url: "xml_to_html",
  },
  {
    title:"CastOff",
    icon:<Icon10 />,
    url:"castoff"
  },
  {
    title:"CSV to WORD",
    icon:<Icon14 />,
    url:"csv_to_word"
  }
  // { title: "Checklist Errors", icon: <Icon2 />, url: "checklist_errors" },
  // {
  //   title: "Validation Report",
  //   icon: <Icon3 />,
  //   url: "epub_validation_report",
  // },
  // { title: "TOC/NCX Compare", icon: <Icon4 />, url: "toc_vs_ncx_compare" },
  // { title: "LaTeX to HTML", icon: <Icon4 />, url: "latex_to_html" },
];

const adminlist = [
  {
    title: "Add new user",
    icon: <Icon6 />,
    url: "add_user",
  },
  {
    title: "Edit user",
    icon: <Icon7 />,
    url: "edit_user",
  },
  {
    title: "Delete user",
    icon: <Icon8 />,
    url: "delete_user",
  },
];

const Leftpanel = ({ leftOpen, admin, setAdmin }) => {
  const [panels, setPanels] = useState([]);
  let { pages } = useParams();
  const navigate = useNavigate();
  let currentpage = pages?.toLowerCase();
  useEffect(() => {
    if (!pages) {
      navigate("/digitalconversion/xml_to_dita");
      setAdmin(false);
      setPanels([...panellist]);
    }
  }, []);

  // useEffect(() => {
  //   if (!admin) {
  //     navigate("/dita/xml_to_dita");
  //   }
  // }, [admin]);

  const { user } = useAuth();

  // useEffect(() => {
  //   const userCategory = "0";
  //   if (user?.super_user === "1" && admin) {
  //     setPanels([...adminlist]);
  //     navigate("/dita/add_user");
  //   }
  // }, [user]);

  return (
    <div
      className="flex flex-col p-8 gap-2 overflow-auto"
      style={{ height: "calc(100vh - 96px)" }}
    >
      <div className="flex flex-col gap-2 h-full">
        {admin
          ? adminlist.length > 0 &&
            adminlist?.map((item, i) => (
              <>
                <Link
                  to={item.url.toLowerCase()}
                  key={i}
                  className={`${
                    leftOpen ? "" : "justify-center"
                  } flex gap-3 items-center overflow-hidden w-full cursor-pointer ${
                    currentpage === item.url.toLowerCase()
                      ? "bg-selectbg"
                      : "bg-none"
                  } ${
                    leftOpen
                      ? "px-6 py-[11px] rounded-[16px]"
                      : "p-3 rounded-[12px]"
                  }`}
                >
                  <div
                    className={`flex justify-center items-center ${
                      currentpage === item.url.toLowerCase()
                        ? "text-white"
                        : "text-title"
                    } `}
                  >
                    {item.icon}
                  </div>
                  {leftOpen && (
                    <p
                      className={`text-18 text-left font-regular ${
                        currentpage === item.url.toLowerCase()
                          ? "text-white"
                          : "text-title"
                      }`}
                    >
                      {item.title}
                    </p>
                  )}
                </Link>
              </>
            ))
          : panellist.length > 0 &&
            panellist?.map((item, i) => (
              <Link
                to={item.url.toLowerCase()}
                key={i}
                className={`${
                  leftOpen ? "" : "justify-center"
                } flex gap-3 items-center overflow-hidden w-full cursor-pointer ${
                  currentpage === item.url.toLowerCase()
                    ? "bg-selectbg"
                    : "bg-none"
                } ${
                  leftOpen
                    ? "px-6 py-[11px] rounded-[16px]"
                    : "p-3 rounded-[12px]"
                }`}
              >
                <div
                  className={`flex justify-center items-center ${
                    currentpage === item.url.toLowerCase()
                      ? "text-white"
                      : "text-title"
                  } `}
                >
                  {item.icon}
                </div>
                {leftOpen && (
                  <p
                    className={`text-18 text-left font-regular ${
                      currentpage === item.url.toLowerCase()
                        ? "text-white"
                        : "text-title"
                    }`}
                  >
                    {item.title}
                  </p>
                )}
              </Link>
            ))}
        {admin ? (
          <button
            onClick={() => {
              setAdmin(false);
              navigate("/digitalconversion/xml_to_dita");
            }}
            className="mt-auto text-red font-semibold"
          >
            Exit Admin Panel
          </button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Leftpanel;
